export const capitalize = (s: string) => s && s[0].toUpperCase() + s.slice(1).toLowerCase();
export const camelCaseFromDashSeparated = (input: string) =>
  input.toLowerCase().replace(/-(.)/g, (match, first: string) => first.toUpperCase());
